export const PRESENCE_OPTIONS = [
  { value: 'online', label: '在线' },
  { value: 'invisible', label: '隐身' },
  { value: 'busy', label: '忙碌' }
]

const LABEL_MAP = {
  online: '在线',
  invisible: '隐身',
  busy: '忙碌'
}

export function normalizePresenceStatus(status) {
  if (status === 'online' || status === 'invisible' || status === 'busy') {
    return status
  }
  return 'online'
}

export function presenceStatusLabel(status) {
  return LABEL_MAP[normalizePresenceStatus(status)] || '在线'
}
